module.exports = __webpack_public_path__ + "static/media/game-console.074070ed.png";